import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zccgzqkkpmqpawelftbw.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpjY2d6cWtrcG1xcGF3ZWxmdGJ3Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMTA5MjI0NSwiZXhwIjoyMDQ2NjY4MjQ1fQ.iocFEGRIrWbZzVwAIBoe0hZOxWVBgrGESlE5RtVWZu0';

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: true, // Ensures the session persists
      storage: localStorage, // Use localStorage for storing the session
    },
  });